import InputComponent from "components/InputG";
import { useState, useEffect } from "react";
import { FaSave } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import {
  MdContactPhone,
  MdEventNote,
  MdPhoneInTalk,
  MdFilterList,
} from "react-icons/md";
import { toast } from "react-toastify";
import { useCriarCampanha } from "services/api/Common_Campanhas/post-criar-campanha";
import { useQuantidadeContatos } from "services/api/Common_Campanhas/post-quantidade-contatos";
import SwitchComponent from "components/SwitchG";
import FilterDrawer from "../FilterDrawer";
import * as S from "./styles";
import CorretoresSelector from "./components/CorretoresSelector";
import { mapearFiltrosParaAPI } from "../../utils";

const CreateCampanha = () => {
  const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false);
  const [nomeCampanha, setNomeCampanha] = useState("");
  const [descricaoCampanha, setDescricaoCampanha] = useState("");
  const [campanhaAtiva, setCampanhaAtiva] = useState(false);
  const [corretoresSelecionados, setCorretoresSelecionados] = useState<
    string[]
  >([]);
  const [filtros, setFiltros] = useState({});

  const history = useHistory();
  const { mutate: criarCampanha, isLoading: isCriarCampanhaPending } =
    useCriarCampanha();
  const { mutate: quantidadeContatos, data: quantidadeContatosData } =
    useQuantidadeContatos();

  // Função para buscar quantidade de contatos
  const buscarQuantidadeContatos = (filtrosAplicados: any) => {
    const filtrosAPI = mapearFiltrosParaAPI(filtrosAplicados);

    quantidadeContatos(filtrosAPI, {
      onError: (error: any) => {
        const notifications = error?.response?.data?.notifications;
        const errorMessages = Array.isArray(notifications)
          ? notifications.map((item: any) => `\n${item?.message}\n`).join("")
          : "Erro ao buscar quantidade de contatos";
        toast.error(errorMessages, { autoClose: 10000 });
      },
    });
  };

  useEffect(() => {
    buscarQuantidadeContatos({});
  }, []);

  const handleSalvarCampanha = (filtrosAplicados: any) => {
    if (!nomeCampanha.trim()) {
      alert("Nome da campanha é obrigatório");
      return;
    }
    const filtrosAPI = mapearFiltrosParaAPI(filtrosAplicados);

    criarCampanha(
      {
        nome: nomeCampanha,
        descricao: descricaoCampanha,
        campanhaAtiva,
        idsCorretorSistemaOrigem: corretoresSelecionados,
        filtros: filtrosAPI,
      },
      {
        onSuccess: () => {
          toast.success("Campanha criada com sucesso!");
          history.push("/campanhas-criadas");
        },
        onError: (error: any) => {
          const notifications = error?.response?.data?.notifications;
          const errorMessages = Array.isArray(notifications)
            ? notifications.map((item: any) => `\n${item?.message}\n`).join("")
            : "Erro ao criar campanha. Tente novamente.";
          toast.error(errorMessages, { autoClose: 10000 });
        },
      }
    );
  };

  return (
    <>
      <S.Container>
        <S.Header>
          <S.Title>CONFIGURAÇÕES DA CAMPANHA</S.Title>
          <S.Line />
        </S.Header>
        <S.Content>
          <S.ContainerLeft style={{ width: "60%" }}>
            <S.FlexContainer>
              <S.ColContainer style={{ width: "100%" }}>
                <InputComponent
                  label="Nome da campanha"
                  onChange={(e) => setNomeCampanha(e.target.value)}
                  value={nomeCampanha}
                  placeholder="Digite o nome da campanha"
                />

                <InputComponent
                  label="Descrição da campanha"
                  onChange={(e) => setDescricaoCampanha(e.target.value)}
                  value={descricaoCampanha}
                  placeholder="Digite a descrição da campanha"
                  multiline
                  type="text"
                  rows={13}
                />
              </S.ColContainer>
              <S.ColContainer style={{ width: "100%" }}>
                <div style={{ marginBottom: "4px" }}>
                  <S.Title3 style={{ marginBottom: "16px" }}>Status</S.Title3>
                  <SwitchComponent
                    label="Campanha ativa"
                    onChange={(e) => setCampanhaAtiva(e.target.checked)}
                    checked={campanhaAtiva}
                    value={campanhaAtiva.toString()}
                  />
                </div>
                <div>
                  <S.TitleData>Minha base de dados</S.TitleData>
                  <S.ContainerData>
                    <S.DataHeader>
                      <S.DataLeft>
                        <S.BigNumber>
                          {quantidadeContatosData?.quantidadeContatos || 0}
                        </S.BigNumber>
                        <S.DataLabel>
                          {quantidadeContatosData?.quantidadeFiltrosAplicados >
                          0
                            ? "contatos filtrados"
                            : "contatos"}
                        </S.DataLabel>
                      </S.DataLeft>
                      <S.FilterButton
                        onClick={() => setIsFilterDrawerOpen(true)}
                      >
                        <MdFilterList />
                        <span>Filtrar contatos</span>
                        {quantidadeContatosData?.quantidadeFiltrosAplicados >
                          0 && (
                          <S.NotificationBadge>
                            {quantidadeContatosData?.quantidadeFiltrosAplicados}
                          </S.NotificationBadge>
                        )}
                      </S.FilterButton>
                    </S.DataHeader>

                    <S.DataInfo>
                      <S.InfoItem>
                        <MdContactPhone size={50} />
                        <S.InfoText>
                          <S.InfoNumber>X.XXX</S.InfoNumber> contatos restantes
                          na campanha
                        </S.InfoText>
                      </S.InfoItem>

                      <S.InfoItem>
                        <MdPhoneInTalk size={24} />
                        <S.InfoText>
                          <S.InfoNumber>XX</S.InfoNumber> ligações diárias
                          (média)
                        </S.InfoText>
                      </S.InfoItem>

                      <S.InfoItem>
                        <MdEventNote size={24} />
                        <S.InfoText>
                          <S.InfoNumber>XX</S.InfoNumber> dias corridos de
                          campanha
                        </S.InfoText>
                      </S.InfoItem>
                    </S.DataInfo>
                  </S.ContainerData>
                </div>
              </S.ColContainer>
            </S.FlexContainer>
          </S.ContainerLeft>
          <S.ContainerRight style={{ width: "40%", minWidth: "350px" }}>
            <S.Title2>Direcionamento de campanha</S.Title2>
            <S.FlexContainer>
              <CorretoresSelector
                corretoresSelecionados={corretoresSelecionados}
                setCorretoresSelecionados={setCorretoresSelecionados}
              />
            </S.FlexContainer>
          </S.ContainerRight>
        </S.Content>
        <S.Footer>
          <S.BackButton onClick={() => history.push("/campanhas-criadas")}>
            ← Voltar
          </S.BackButton>
          <S.NewCampaignButton
            onClick={() => handleSalvarCampanha(filtros)}
            disabled={isCriarCampanhaPending}
          >
            <FaSave />{" "}
            {isCriarCampanhaPending ? "Salvando..." : "Salvar Campanha"}
          </S.NewCampaignButton>
        </S.Footer>
      </S.Container>
      <S.StyledSwipeableDrawer
        anchor="right"
        open={isFilterDrawerOpen}
        onClose={() => setIsFilterDrawerOpen(false)}
        onOpen={() => setIsFilterDrawerOpen(true)}
      >
        <FilterDrawer
          onCloseModal={() => setIsFilterDrawerOpen(false)}
          onApplyFilters={(filters) => {
            setFiltros(filters);
            buscarQuantidadeContatos(filters);
            setIsFilterDrawerOpen(false);
          }}
          onClearFilters={() => {
            setFiltros({});
            buscarQuantidadeContatos({});
          }}
          isOpen={isFilterDrawerOpen}
        />
      </S.StyledSwipeableDrawer>
    </>
  );
};

export default CreateCampanha;
